import React from 'react'

export const alabamaSetupVars = {
  siteId: 'alabama',
  pathPrefix: '/al',
  menuHeader: "Discover Alabama's Solution for:",
  appUrl: 'https://al.headed2.com',
  logoImg: '/images/assets/alabama/horizontal/dark.svg',
  headerTitle: `The Alabama CareerExplorer is a system designed for Alabama`
}
